import { render, staticRenderFns } from "./AppSideEffectsGoodStuff.vue?vue&type=template&id=5b9432ca&scoped=true&"
import script from "./AppSideEffectsGoodStuff.vue?vue&type=script&lang=js&"
export * from "./AppSideEffectsGoodStuff.vue?vue&type=script&lang=js&"
import style0 from "./AppSideEffectsGoodStuff.vue?vue&type=style&index=0&id=5b9432ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9432ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
